import { CopyButton } from '../components/CopyButton'

const MOCK_SHOWCASE = [
  { id: '1', name: '极简办公 + 飞书', tags: ['飞书', '办公'], tokens: '约 5k/天', channels: '飞书' },
  { id: '2', name: '开发 + GitHub + Vercel', tags: ['开发', 'DevOps'], tokens: '约 15k/天', channels: 'TUI, Slack' },
  { id: '3', name: '知识库 + 搜索', tags: ['知识库', '研究'], tokens: '约 10k/天', channels: 'Telegram' },
]

export function Community() {
  return (
    <div className="page">
      <h1 className="section-title">玩家社区</h1>
      <p className="lead" style={{ marginBottom: '2rem' }}>
        抄作业广场、一键配置生成、黑红榜与安全测评。配置均在本地生成，不上传密钥。
      </p>

      <div className="card">
        <h2>抄作业广场 (Config Showcase)</h2>
        <p>用户可分享脱敏后的 <code>openclaw.json</code> 与 Skills 列表。以下为示例，实际可从社区接口拉取。</p>
      </div>

      <div className="showcase-grid">
        {MOCK_SHOWCASE.map((item) => (
          <div key={item.id} className="card">
            <h3>{item.name}</h3>
            <div className="tags">
              {item.tags.map((t) => (
                <span key={t} className="tag">{t}</span>
              ))}
            </div>
            <p className="meta">Token 估算：{item.tokens} · 通道：{item.channels}</p>
            <CopyButton text={`npx clawhub install ${item.id}`} label="一键拉取命令" />
          </div>
        ))}
      </div>

      <div className="card">
        <h2>一键配置生成器</h2>
        <p>选择某份「作业」后，可生成 Docker Compose 或安装脚本代码，均在浏览器内完成。接入 ClawHub 时使用 <code>npx clawhub install &lt;skill-slug&gt;</code> 拉取打包环境。</p>
      </div>

      <div className="card">
        <h2>黑红榜与安全测评</h2>
        <p>用户对社区 Skills 打分，标记「宝藏好用」或「有潜在风险/恶意代码」，建立社区自净化机制。使用前请结合 ClawDex 与 SKILL.md 审计。</p>
      </div>
    </div>
  )
}
